export const getRequiredDepthForRollers = (
  productType: string,
  driveControl: string,
) => {
  if (productType === '' || driveControl === '') return [];
  const driveControlStripped = driveControl.replace('Drive Control: ', '');
  const singleRollerBlindDepths = [
    {
      driveControl: 'Chain',
      depth: '86mm',
    },
    {
      driveControl: 'Smartglide',
      depth: '86mm',
    },
  ];

  const dayNightRollerBlindDepths = [
    {
      driveControl: 'Chain',
      depth: '96mm',
    },
    {
      driveControl: 'Smartglide',
      depth: '96mm',
    },
  ];

  if (productType.includes('Day/Night')) {
    return dayNightRollerBlindDepths.filter(
      options => options.driveControl === driveControlStripped,
    );
  } else {
    return singleRollerBlindDepths.filter(
      options => options.driveControl === driveControlStripped,
    );
  }
};
